import { useCallback, useLayoutEffect, useRef } from 'react';

export const ScanDescriptionInput = ({ id, value, onChange, testId }) => {
  const ref = useRef(null);
  const fit = useCallback(() => {
    const input = ref.current;
    if (!input) return;
    input.style.height = '36px';
    input.style.height = `${Math.max(36, input.scrollHeight + 2)}px`;
  }, []);
  useLayoutEffect(() => { fit(); }, [fit, value]);
  useLayoutEffect(() => {
    let width = -1;
    let frame;
    const observer = new ResizeObserver(entries => {
      const nextWidth = entries[0]?.contentRect.width;
      if (nextWidth !== width) {
        width = nextWidth;
        cancelAnimationFrame(frame);
        // Never change observed geometry during the observer's notification cycle.
        frame = requestAnimationFrame(fit);
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => { observer.disconnect(); cancelAnimationFrame(frame); };
  }, [fit]);
  return <textarea ref={ref} id={id} rows={1} value={value || ''} title={value || ''}
    onChange={e => onChange(e.target.value)} data-testid={testId}
    className="field-input w-full text-sm leading-5 !min-h-0 !py-[7px] !resize-none !overflow-hidden" />;
};